/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LogicModule } from './logicModule';
import { PromotionInfo } from './promotionInfo';
import { Parameter } from './parameter';
import { CampainInfo } from './campainInfo';

/**
 * Init flow response
 */
export interface InitFlowResponse {
  campaignInfo?: CampainInfo;
  promotionInfo?: PromotionInfo;
  correlationId?: string;
  ratingDate?: object;
  parameters?: Array<Parameter>;
  logicModules?: Array<LogicModule>;
}
